import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useTranslation } from "react-i18next";

/**
 * Shown when a user with the entered email already exists.
 *
 * The existing user may be invisible for the current admin (e.g. an application admin creating a user that
 * so far only has roles in other applications), so we only offer to add the entered applications to him.
 */
export function ExistingUserDialog(props: {
  open: boolean,
  onClose: () => void,
  onConfirm: () => void
}) {
  const {t} = useTranslation();

  return (
    <Dialog open={ props.open } onClose={ props.onClose }>
      <DialogTitle>{ t('UserPage.existingUser.title') }</DialogTitle>
      <DialogContent>
        <DialogContentText>{ t('UserPage.existingUser.message') }</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={ props.onClose } color="primary">{ t('buttons.cancel') }</Button>
        <Button onClick={ props.onConfirm } color="primary" variant="contained">{ t('UserPage.existingUser.confirm') }</Button>
      </DialogActions>
    </Dialog>
  );
}
